import { makeStyles } from "@material-ui/core/styles";
import { secondary } from "../../../../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  filtersContainer: {
    marginBottom: theme.spacing(2),
  },
  filter: {
    marginRight: theme.spacing(2),
  },
  pieContainer: {
    minHeight: 300,
  },
  spinner: {
    color: secondary,
  },
  svg: {
    margin: `${theme.spacing(8)}px ${theme.spacing(32)}px`,
    width: 240,
    height: 180,
  },
}));

export default useStyles;
